import { useState } from 'react';
import SelectTile from '../webapp/core/SelectTile';
import Backdrop from './Backdrop';

const effects = [
  {
    id: 'BWColorGlass',
    name: 'bwcolorglass',
  },
  {
    id: 'Dog',
    name: 'dog',
  },
  {
    id: 'Flower',
    name: 'flower',
  },
];

const FaceEffectDemo = ({ backdrop }) => {
  const [currentEffect, setCurrentEffect] = useState(effects[0].id);

  const handleEffectChange = (effect) => {
    if (effect.value) {
      setCurrentEffect(effect.id);
    }
  };

  return (
    <div className="face-effect-demo">
      <div className="video-demo face-effect-demo__capture">
        <Backdrop backdrop={backdrop} animated={false} />
        <img className="video-demo__photo" src={`/static/face-effects/demo/${currentEffect}.png`} alt="" />
        <div className="video-demo__overlay"></div>
      </div>
      {effects.length > 1 && (
        <div className="face-effect-demo__controls">
          {effects.map((effect) => (
            <SelectTile
              key={effect.id}
              id={effect.id}
              name="effect"
              type="radio"
              label={effect.name}
              labelHidden={true}
              autoHeight={true}
              onChange={handleEffectChange}
              selected={currentEffect === effect.id}
            >
              <img alt={effect.name} src={`/static/face-effects/thumbs/${effect.id}.png`} width={50} height={50} />
            </SelectTile>
          ))}
        </div>
      )}
    </div>
  );
};

export default FaceEffectDemo;
